<h2 mat-dialog-title>{{'FORM.huntingDistrictForm.select_fr_list' | translate}}</h2>
<mat-dialog-content>
    <div class=" px-3 sticky-top" style="background: #ffffff;z-index: 23;">
        <app-text-filter *ngIf="!showLoading" (searchString)="filterItems($event)"  [loadingPagination]="showLoading"></app-text-filter>
    </div>

    <div *ngIf="filteredList$ | async as list; else loading" class="my-2" >

        <div *ngIf="list.length > 0; else noItems" class="my-2">
            <form [formGroup]="optionForm">
                <mat-selection-list #optionList formControlName="listOption" name="option" [multiple]="false">
                    @for (option of list; track option; ) {
                        <mat-list-option [value]="option.id" (click)="setSelectedOption(option.id, option.name)">{{option?.name}}</mat-list-option>
                    }
                </mat-selection-list>
                <p> {{'option_selected' | translate}} {{optionForm.value?.veterinaryAuthorityName ? optionForm.value?.veterinaryAuthorityName : 'None'}} </p>
            </form> 
        </div>
    </div>

    <ng-template #loading>
        Loading...
    </ng-template>
    <ng-template #noItems>
        Keine Items
    </ng-template>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [mat-dialog-close] class="second-btn">{{'gen_dialog_btn_cancle' | translate}}</button>
  <button mat-button *ngIf="!selectedTemplate" cdkFocusInitial (click)="onSelectVetAuthId()" [disabled]="!optionForm.value?.veterinaryAuthorityId" class="first-btn">{{'select' | translate}}</button>
  <button mat-button *ngIf="selectedTemplate" cdkFocusInitial (click)="onSelectTemplate()" class="first-btn">{{'load_template' | translate}}</button>
</mat-dialog-actions>